module.exports = __webpack_public_path__ + "static/DDell-a856d8e774b596db0832a7e40c07b388.png";